function mustEnv(name: keyof ImportMetaEnv): string {
  const v = import.meta.env[name];
  if (!v || !v.trim()) {
    throw new Error(`Missing env ${name}. Set it in Cloudflare Pages or .env.local`);
  }
  return v;
}

export const SUPABASE_URL = mustEnv('VITE_SUPABASE_URL');
export const SUPABASE_ANON_KEY = mustEnv('VITE_SUPABASE_ANON_KEY');

export const SENTRY_DSN = import.meta.env.VITE_SENTRY_DSN?.trim() ?? '';
export const SENTRY_ENVIRONMENT = import.meta.env.VITE_SENTRY_ENVIRONMENT?.trim() || 'local';
export const SENTRY_RELEASE = import.meta.env.VITE_SENTRY_RELEASE?.trim() || `web-admin@${__APP_VERSION__}`;
